export const CONTEXT_SUGGESTED_REPLY = 'iglu:com.gladly.agent_desktop/context_suggested_reply/jsonschema/1-0-0';
export const getSuggestedReplyContext = id => ({
  schema: CONTEXT_SUGGESTED_REPLY,
  data: {
    id,
  },
});
